import React, { useEffect, useState } from "react";
import {
  Typography,
  Steps,
  DatePicker,
  Modal,
  Select,
  Table,
  Form,
  Row,
  Col,
  InputNumber,
  Input,
  Alert,
  Checkbox,
  Drawer,
  Popconfirm,
  TreeSelect,
  Tag,
  Badge,
} from "antd";
import moment from "moment";
import {
  CardDieuKhoan,
  errorHandle,
  getDateRange,
  getDaysArray,
  openNotificationWithIcon,
  validatePermission,
} from "../../Function";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import "antd-button-color/dist/css/style.css";
import {
  CheckSquareOutlined,
  CloseCircleOutlined,
  CloseSquareOutlined,
  DownloadOutlined,
  EyeOutlined,
  FileSearchOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import ListTeamApi, { ListBoPhanApi } from "../../../api/getListTeam";
import { GetChucVuApi } from "../../../api/usersApi";
import {
  GetDangKyWFHQLyApi,
  GetDetailWFHApi,
  ListThietBiTruyCapApi,
  PutDKWFHQLyApi,
} from "../../../api/GetCamKetWFH";

const { Title, Link } = Typography;

const validateMessages = {
  required: "${label} là bắt buộc.",
  types: {},
  number: {},
};

const renderStatusTag = (record) => {
  return (
    <Tag
      color={record.trangthai__background}
      key={record.trangthai__tenTrangthai}
      style={{
        color: record.trangthai__color,
        fontWeight: "600",
        borderRadius: 10,
        border: `1px solid ${record.trangthai__color}`,
      }}
    >
      {record.trangthai__tenTrangthai}
    </Tag>
  );
};

const ModalDetailWFH = ({ visible, onCancel, recordDetail }) => {
  const [form] = Form.useForm();

  const fetchDetailWFH = (recordDetail) => {
    GetDetailWFHApi(recordDetail.id)
      .then((re) => {
        form.setFieldsValue({
          username: re.data["user__username"],
          bophan: re.data["ten_bophan"],
          chucVu: re.data["ten_chucvu"],
          team: re.data["user__fore_team__tenTeam"],
          ckbAgree: re.data["is_confirm_terms"],
          soDT: re.data["sdt"],
          soCMND: re.data["soCMND_CCCD"],
          date:
            re.data["ngaycap"] == null
              ? null
              : moment(re.data["ngaycap"], "YYYY-MM-DD").format("DD/MM/YYYY"),
          noicap: re.data["noicap"],
          diachi: re.data["diachi"],
          tungay:
            re.data["tungay"] == null
              ? null
              : moment(re.data["tungay"], "YYYY-MM-DD").format("DD/MM/YYYY"),
          denngay:
            re.data["denngay"] == null
              ? null
              : moment(re.data["denngay"], "YYYY-MM-DD").format("DD/MM/YYYY"),
          noilamtuxa: re.data["noilamviectuxa"],
          ten_thietbi: re.data["ten_thietbi"],
          phuongan: re.data["phuongantruycaptuxa"],
        });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  useEffect(() => {
    form.resetFields();
    if (visible == true) {
      fetchDetailWFH(recordDetail);
    }
  }, [visible]);

  // const handleHover = (fieldName) => {
  //   const fieldValue = form.getFieldValue(fieldName);
  //   if (fieldValue) {
  //     return fieldValue;
  //   } else {
  //     return "";
  //   }
  // };

  return (
    <Modal
      title={<>Chi tiết Đăng ký làm từ xa {renderStatusTag(recordDetail)}</>}
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={1000}
      className={"site-drawer-render-in-current-wrapper"}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        autoComplete="off"
        validateMessages={validateMessages}
        disabled
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Nhân viên"
              name="username"
              rules={[{ required: true }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Chức vụ"
              name="chucVu"
              rules={[{ required: true }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Bộ phận"
              name="bophan"
              rules={[{ required: true }]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Team" name="team" rules={[{ required: true }]}>
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="Số ĐT" name="soDT" rules={[{ required: true }]}>
              <Input
                maxLength={12}
                style={{ width: "100%" }}
                pattern="[0-9]*"
                title="Chỉ nhập ký tự từ 0 đến 9"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Số CMND/CCCD/Hộ chiếu"
              name="soCMND"
              rules={[{ required: true }]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Ngày cấp"
              name="date"
              rules={[{ required: true }]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Nơi Cấp"
              name="noicap"
              rules={[{ required: true }]}
              tooltip={<FileSearchOutlined />}
            >
              <Input maxLength={150} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Địa chỉ"
              name="diachi"
              rules={[{ required: true }]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Nơi làm việc từ xa"
              name="noilamtuxa"
              rules={[{ required: true }]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Từ ngày"
              name="tungay"
              rules={[{ required: true }]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Đến ngày"
              name="denngay"
              rules={[{ required: true }]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Thiết bị truy cập từ xa"
              name="ten_thietbi"
              rules={[{ required: true }]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Phương án làm việc từ xa"
              name="phuongan"
              rules={[{ required: true }]}
            >
              <Input maxLength={300} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="ckbAgree"
          valuePropName={"checked"}
          style={{
            border: "1px solid #99d55c",
            paddingLeft: "5px",
            backgroundColor: "#f6ffed",
          }}
        >
          <Checkbox>
            &nbsp;Tôi đã đọc và đồng ý <a className="text-link">điều khoản</a>{" "}
            làm việc từ xa!
          </Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const CamKetWFH_NS = () => {
  const defaultPageSize = 50;
  const [pager, setPager] = useState({ pageSize: defaultPageSize });
  const [data, setData] = useState([]);
  const [lsDate, setLsDate] = useState(getDateRange(moment(new Date())));
  const [lsTeam, setLsTeam] = useState([]);
  // const [lsChucVu, setLsChucVu] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  // const [lsMemberId, setLsMemberId] = useState([]);
  const [currentSelectedDate, setCurrentSelectedDate] = useState(
    moment(new Date())
  );
  const [loading, setLoading] = useState(false);
  const [lsThietBiWFH, setLsThietBiWFH] = useState([]);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);
  // const [statusAll, setStatusAll] = useState(null);
  const [treeData, setTreeData] = useState([]);

  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [recordDetail, setRecordDetail] = useState([]);
  const [isShowDetail, setIsShowDetail] = useState(false);

  const fetchData = (params = {}) => {
    setLoading(true);
    GetDangKyWFHQLyApi({
      listIdTeam: JSON.stringify(params.idTeam),
      tuNgay: moment(currentSelectedDate).startOf("month").format("YYYYMMDD"),
      denNgay: moment(currentSelectedDate).endOf("month").format("YYYYMMDD"),
    })
      .then((res) => {
        // console.log(res.data);
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter((item) => item.phanquyen__ten_pq === "is_wfh_commit_ns")
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // 200423 lấy element đầu tiên đặt trong list
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
    });
  };

  // const fetchListChucVu = () => {
  //   GetChucVuApi().then((res) => {
  //     setLsChucVu(res.data);
  //   });
  // };

  const fetchListTBTruyCap = () => {
    ListThietBiTruyCapApi().then((res) => {
      setLsThietBiWFH(res.data);
    });
  };

  useEffect(() => {
    // fetchListChucVu();
    fetchListTBTruyCap();
  }, []);

  useEffect(() => {
    if (lsDate.length > 0 && currentTeam.length > 0) {
      fetchData({ idTeam: currentTeam, lsDate: lsDate });
    }
    if (currentTeam.length === 0) {
      setData([]);
    }
  }, [currentSelectedDate, currentTeam]);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
    }
  }, [userInfo]);

  const updateData = () => {
    fetchData({ idTeam: currentTeam, lsDate: lsDate });
  };

  const onChangeMonth = (date) => {
    setCurrentSelectedDate(date);
    const lsDateTemp = getDateRange(date);
    setLsDate(lsDateTemp);
  };

  const onQuickChangeMonth = (type) => {
    let monthChange;
    if (type === "previous") {
      monthChange = moment(currentSelectedDate).subtract(1, "month");
    } else {
      monthChange = moment(currentSelectedDate).add(1, "month");
    }
    setCurrentSelectedDate(monthChange);
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    // console.log(value);
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => setCurrentTeam([])}
              className="style_SelectTeam"
              // style={{
              //   display: "inline-block",
              //   color: "#286FBE",
              //   cursor: "pointer",
              // }}
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => setCurrentTeam(lsTeam.map((item) => item.idTeam))}
              className="style_SelectTeam"
              // style={{
              //   display: "inline-block",
              //   color: "#286FBE",
              //   cursor: "pointer",
              // }}
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
    // if (currentTeam.length === 0){
    //     setCurrentTeam(lsTeam.map(item=>item.idTeam));
    // };
  }, [lsTeam]);

  const onShowModalDetail = (record) => {
    setIsShowDetail(true);
    setRecordDetail(record);
  };

  const onAgree = (record, boolAgree) => {

    PutDKWFHQLyApi({
      idWFH: record.id,
      maTrangthai: boolAgree,
      lydoKhongduyet: "",
      id_rule_hr: 'true',

    })
      .then((r) => {
        fetchData({ idTeam: currentTeam });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const getButtonChangeStatus = (record) => {
    const arrTeam = userInfo.team_permissions
      .filter(
        (item) =>
          (item.phanquyen__ten_pq === "wfh_commit_accept" ||
            item.phanquyen__ten_pq === "wfh_commit_reject") &&
          item.team__tenTeam == record.user__fore_team__tenTeam
      )
      .map((item, index) => {
        return item.phanquyen__ten_pq;
      });

    const checkPermissionDuyet = validatePermission(
      arrTeam,
      "wfh_commit_accept"
    );
    const checkPermissionKhongDuyet = validatePermission(
      arrTeam,
      "wfh_commit_reject"
    );
    return (
      <Row>
        <Col span={3}>
          <span
            title="Chi tiết"
            className={"col-6"}
            style={{ color: "#4290d3", cursor: "pointer" }}
            onClick={() => onShowModalDetail(record)}
          >
            <EyeOutlined />
          </span>
        </Col>

        {
        record.trangthai__tenTrangthai === "Không duyệt" ? (
          ""
        ) : (
          <>
            {/* {checkPermissionDuyet && (
              <Col span={3}>
                <span
                  title={"Duyệt"}
                  className={"col-6"}
                  style={{ color: "#008000", cursor: "pointer" }}
                >
                  <Popconfirm
                    title="Xác nhận duyệt"
                    onConfirm={() => onAgree(record, 1)}
                    okText="Duyệt"
                  >
                    <CheckSquareOutlined style={{ color: "#008000" }} />
                  </Popconfirm>
                </span>
              </Col>
            )} */}
            {checkPermissionKhongDuyet && (
              <Col span={3}>
                <span
                  title={"Không duyệt"}
                  className={"col-6"}
                  style={{ color: "#ff4d4f", cursor: "pointer" }}
                >
                  <Popconfirm
                    title="Xác nhận không duyệt"
                    onConfirm={() => onAgree(record, 2)}
                    okText="Không duyệt"
                  >
                    <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
                  </Popconfirm>
                </span>
              </Col>
            )}
          </>
        )}
      </Row>
    );
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Nhân viên",
      dataIndex: "user__username",
      key: "user__username",
      filterKey: "user__username",
      type: "text",
      canSearch: true,
      render: (text, record) => record.user__msnv + "-" + text,
    },
    {
      title: "Từ ngày",
      dataIndex: "tungay",
      key: "tungay",
      filterKey: "tungay",
      type: "text",
      canSearch: true,
      render: (text) => moment(new Date(text)).format("DD/MM/YYYY"),
    },
    {
      title: "Đến ngày",
      dataIndex: "denngay",
      key: "denngay",
      filterKey: "denngay",
      type: "text",
      canSearch: true,
      render: (text) => moment(new Date(text)).format("DD/MM/YYYY"),
    },
    {
      title: "Địa điểm làm từ xa",
      dataIndex: "noilamviectuxa",
      key: "noilamviectuxa",
      filterKey: "noilamviectuxa",
      type: "text",
      canSearch: true,
    },
    {
      title: "Thiết bị truy cập",
      dataIndex: "thietbi",
      key: "thietbi",
      filterKey: "thietbi",
      type: "text",
      canSearch: true,
      render: (text) =>
        lsThietBiWFH
          .filter((item) => item.id === text)
          .map((i) => i.ten_thietbi),
    },
    {
      title: "Số điện thoại",
      dataIndex: "sdt",
      key: "sdt",
      filterKey: "sdt",
      type: "text",
      canSearch: true,
    },
    {
      title: "Trạng thái",
      dataIndex: "trangthai__tenTrangthai",
      key: "trangthai__tenTrangthai",
      filterKey: "trangthai__tenTrangthai",
      type: "text",
      canSearch: true,
      render: (text, record) => renderStatusTag(record),
    },
    {
      title: "Thao tác",
      dataIndex: "action",
      key: "action",
      filterKey: "action",
      type: "text",
      canSearch: true,
      render: (text, record) => getButtonChangeStatus(record),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">
              Danh Sách Đăng Ký Làm Từ Xa
            </h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link href="#">Nhân sự</Link>
                </li>
                <li className="breadcrumb-item active">Đăng ký làm từ xa</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className={"col-12 mb-2 d-sm-flex align-items-center"}>
          <div className={"col"}>
            <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("previous")}
              title="Tuần trước"
            >
              <i className={"fa fa-arrow-left"}></i>
            </Button>
            <Button
              type="primary"
              className={"m-2 styleNtn_1"}
              onClick={() => onQuickChangeMonth("next")}
              title="Tuần sau"
            >
              <i className={"fa fa-arrow-right"}></i>
            </Button>
            <DatePicker
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeMonth}
              value={currentSelectedDate}
              picker="month"
              format={"MM/YYYY"}
              allowClear={false}
            />
            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
            {/* <Button type="success" className={'m-2'} icon={<DownloadOutlined />}>Tải xuống</Button> */}
          </div>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          // scroll={{x:1920}}
          sticky={true}
          size={"small"}
          rowKey="id"
          pagination={false}
        />
      </div>
      <ModalDetailWFH
        visible={isShowDetail}
        onCancel={() => setIsShowDetail(false)}
        recordDetail={recordDetail}
      />
    </>
  );
};
